export function initDynamicVH(onChange) {
    let maxH = window.visualViewport?.height ?? window.innerHeight;
    const update = () => {
        const currentH = window.visualViewport?.height ?? window.innerHeight;
        if (currentH < maxH)
            return;
        maxH = currentH;
        const vhPx = `${maxH}px`;
        document.documentElement.style.setProperty('--vh', `calc(${vhPx} / 100)`);
        onChange?.(vhPx);
    };
    update();
    const tgt = window.visualViewport ?? window;
    tgt.addEventListener('resize', update, { passive: true });
    const resetOnRotate = () => {
        maxH = window.visualViewport?.height ?? window.innerHeight;
        update();
    };
    window.addEventListener('orientationchange', resetOnRotate, { passive: true });
    return () => {
        tgt.removeEventListener('resize', update);
        window.removeEventListener('orientationchange', resetOnRotate);
    };
}
